import React from 'react';
import { Heart, Github, Instagram, Twitter, Linkedin, ArrowUp } from 'lucide-react';
import { socialLinks, profileData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const socialIcons = {
  github: Github,
  instagram: Instagram,
  twitter: Twitter,
  linkedin: Linkedin
};

const Footer = () => {
  const { t } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="py-12 px-6 border-t border-purple-500/10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo/Name */}
          <div className="text-center md:text-left">
            <a href="#" className="text-2xl font-bold gradient-text" aria-label="Ömer Karani Denizoglu">ÖKD</a>
            <p className="text-gray-500 text-sm mt-1">{profileData.title}</p>
          </div>

          {/* Social links */}
          <nav className="flex items-center gap-4" aria-label="Social media links">
            {socialLinks.map((social) => {
              const Icon = socialIcons[social.icon];
              return (
                <a
                  key={social.id}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 text-gray-400 hover:text-purple-400 transition-colors duration-300"
                  aria-label={social.name}
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </nav>

          {/* Scroll to top */}
          <button
            onClick={scrollToTop}
            className="p-3 rounded-xl bg-purple-500/10 border border-purple-500/20 hover:border-purple-500/50 hover:bg-purple-500/20 transition-all duration-300 group"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-5 h-5 text-purple-400 group-hover:-translate-y-1 transition-transform duration-300" />
          </button>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-purple-500/10 text-center">
          <p className="text-gray-500 text-sm flex items-center justify-center gap-2">
            © {new Date().getFullYear()} {profileData.name}. {t('footer.madeWith')} 
            <Heart className="w-4 h-4 text-purple-500 fill-purple-500" />
            {t('footer.in')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
